import React from "react";
import PropTypes from "prop-types";
import { Button, Grid, Typography, Divider } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import { ContentsById } from "../../models/api/contentsById";
import { useStyles } from "./recommended-content-pagination.styles";

interface RecommendedContentPaginationProps {
  relatedContent: ContentsById[];
  currentContentId: number;
  prevContentId: number;
  nextContentId: number;
  handlePaginationClick: (contentId: number) => void;
}

export const RecommendedContentPagination = ({
  relatedContent,
  handlePaginationClick,
  currentContentId,
  prevContentId,
  nextContentId,
}: RecommendedContentPaginationProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Divider />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          {currentContentId > 0 && (
            <>
              <Button
                startIcon={<ArrowBackIos className={classes.buttonIcon} />}
                onClick={() => handlePaginationClick(prevContentId)}
              >
                Previous
              </Button>
              <Typography>
                {relatedContent[currentContentId - 1]?.title}
              </Typography>
            </>
          )}
        </Grid>
        <Grid item>
          {currentContentId < relatedContent.length - 1 && (
            <>
              <Button
                endIcon={<ArrowForwardIos className={classes.buttonIcon} />}
                onClick={() => handlePaginationClick(nextContentId)}
              >
                Next
              </Button>
              <Typography>
                {relatedContent[currentContentId + 1]?.title}
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
      <Divider />
      <br />
    </div>
  );
};

RecommendedContentPagination.propTypes = {
  relatedContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      contentId: PropTypes.number.isRequired,
    })
  ),
};

RecommendedContentPagination.defaultProps = {
  relatedContent: [],
};
